import { render, staticRenderFns } from "./DeviceRestrictionDetails.vue?vue&type=template&id=5a876154&scoped=true&"
import script from "./DeviceRestrictionDetails.vue?vue&type=script&lang=js&"
export * from "./DeviceRestrictionDetails.vue?vue&type=script&lang=js&"
import style0 from "./DeviceRestrictionDetails.vue?vue&type=style&index=0&id=5a876154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a876154",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1768404630/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a876154')) {
      api.createRecord('5a876154', component.options)
    } else {
      api.reload('5a876154', component.options)
    }
    module.hot.accept("./DeviceRestrictionDetails.vue?vue&type=template&id=5a876154&scoped=true&", function () {
      api.rerender('5a876154', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/DeviceRestrictionDetails.vue"
export default component.exports